import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type {
  ChannelForm,
  ChannelGroups,
  SelectedChannel,
  SelectedChannelGroup,
} from "~/modules/Settings/Channel/types";
import type { RootState } from "~/store";

type ChannelSettingState = {
  isChannelGroupsLoading: boolean;
  channelGroups: ChannelGroups | null;
  currentChannelGroup: SelectedChannelGroup | null;
  currentChannel: SelectedChannel | null;
  channelForm: ChannelForm | null;
  shouldFetchChannelGroup: boolean;
};

const initialState: ChannelSettingState = {
  isChannelGroupsLoading: false,
  channelGroups: null,
  currentChannelGroup: null,
  currentChannel: null,
  channelForm: null,
  shouldFetchChannelGroup: true,
};

export const channelSettingSlice = createSlice({
  name: "channelSetting",
  initialState,
  reducers: {
    updateIsChannelGroupsLoading: (state, action: PayloadAction<boolean>) => {
      state.isChannelGroupsLoading = action.payload;
    },
    updateChannelGroups: (
      state,
      action: PayloadAction<ChannelGroups | null>,
    ) => {
      state.channelGroups = action.payload;
    },
    updateCurrentChannelGroup: (
      state,
      action: PayloadAction<SelectedChannelGroup | null>,
    ) => {
      state.currentChannelGroup = action.payload;
    },
    updateCurrentChannel: (
      state,
      action: PayloadAction<SelectedChannel | null>,
    ) => {
      state.currentChannel = action.payload;
    },
    updateChannelForm: (state, action: PayloadAction<ChannelForm | null>) => {
      state.channelForm = action.payload;
    },
    updateShouldFetchChannelGroup: (state, action) => {
      state.shouldFetchChannelGroup = action.payload;
    },
  },
});

const selectIsChannelGroupsLoading = (state: RootState) =>
  state.channelSetting.isChannelGroupsLoading;
const selectChannelGroups = (state: RootState) =>
  state.channelSetting.channelGroups;
const selectCurrentChannelGroup = (state: RootState) =>
  state.channelSetting.currentChannelGroup;
const selectCurrentChannel = (state: RootState) =>
  state.channelSetting.currentChannel;
const selectChannelForm = (state: RootState) =>
  state.channelSetting.channelForm;
const selectShouldFetchChannelGroup = (state: RootState) =>
  state.channelSetting.shouldFetchChannelGroup;

export {
  selectIsChannelGroupsLoading,
  selectChannelGroups,
  selectCurrentChannelGroup,
  selectCurrentChannel,
  selectChannelForm,
  selectShouldFetchChannelGroup,
};

export const {
  updateIsChannelGroupsLoading,
  updateChannelGroups,
  updateCurrentChannelGroup,
  updateCurrentChannel,
  updateChannelForm,
  updateShouldFetchChannelGroup,
} = channelSettingSlice.actions;

export default channelSettingSlice.reducer;
